<template>
  <a 
    href="#" 
    :class="{'muted': !isActive, 'text-gray-500  hover:text-gray-200': isGalleryModal}" 
    v-if="show" 
    @click.prevent="click"
  >
    <aw-icon icon="export" class="w-5 h-5 "></aw-icon>
    <span v-if="!isGalleryModal">
      {{$t('Export to PDF')}}
    </span>
  </a>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import { trackEvent } from '../../gtm'
import ShareGalleryModal from '../../mixins/ShareGalleryModal'

export default {
  mixins: [
    ShareGalleryModal
  ],
  computed: {
    show () {
      return this.$route.matched[0].name !== 'BCSharedDocument' && (this.$route.matched[0].name !== 'BCDocument' || this.bcDocumentStore.documentRev === null)
    },
    isActive () {
      return this.bcSelectedStore.defaultSelected !== false || this.bcSelectedStore.listSelected.length > 0
    },
    ...mapStores(useBcSelectedStore, useBcDocumentStore),
  },
  methods: {
    click() {
      this.selectAllGalleryModal()

      this.$store.commit('nette/updateControl', {
        controlName: 'exportToPdfForm',
        data: true,
        key: 'showModal',
      })
      trackEvent(this.$route.matched[0].name, 'showExportPdfForm')
    }
  },
}
</script>

<style lang="scss" scoped></style>
